<template>
  <div class="microStationSetup" v-if="permisShow('微站设置')">
    <div class="key_title">
      <span
        v-for="(item,index) in tabData"
        :key="index"
        v-bind:class="{ activeBtn:index===isActive}"
        @click="ClassChang(index)"
      >{{item}}</span>
    </div>
    <div class="basicSet" v-if="isShow">
      <ul class="basicSet_item">
        <li class="item_one">
          <span>微站名称：</span>
          <el-input v-model="data.weiName"></el-input>
        </li>
        <li class="item_one">
          <span>公司logo：</span>
          <el-upload
            class="upload-demo"
            :action="`${$uploadUrl}/erp/qiniu/uploadImg`"
            :on-success="handleAvatarSuccesslogo"
            accept=".png, .jpg, .jpeg"
            :multiple="false"
            :show-file-list="false"
            :headers="headers"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </li>
        <li class="item_one" v-if="data.weiLogo">
          <div
            style="width:375px;height:180px;border:1px solid #eee;display:flex;align-items:center;justify-content:center;"
          >
            <img :src="'http://'+data.weiLogo" alt="公司logo" style="width:140px;height:32px;" />
          </div>
        </li>
        <li class="item_one">
          <p style="color:#FF4700">建议尺寸：280*64像素</p>
        </li>
      </ul>
      <ul class="basicSet_item">
        <li class="item_one">
          <span>首页图片：</span>
          <el-upload
            class="upload-demo"
            :action="`${$uploadUrl}/erp/qiniu/uploadImg`"
            :on-success="handleAvatarSuccess"
            accept=".png, .jpg, .jpeg"
            :multiple="false"
            :show-file-list="false"
            :headers="headers"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </li>
        <li class="item_one" v-if="data.homePicture">
          <img :src="'http://'+data.homePicture" alt="首页图片" />
        </li>
        <li class="item_one">
          <p style="color:#FF4700">建议尺寸：750*360像素</p>
        </li>
      </ul>
      <ul class="basicSet_item">
        <li class="item_one">
          <span>房源默认图片：</span>
          <el-upload
            class="upload-demo"
            :action="`${$uploadUrl}/erp/qiniu/uploadImg`"
            :on-success="handleAvatarSuccesswei"
            accept=".png, .jpg, .jpeg"
            :multiple="false"
            :show-file-list="false"
            :headers="headers"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </li>
        <li class="item_one" v-if="data.weiHousePicture">
          <img :src="'http://'+data.weiHousePicture" alt="房源默认图片" style="width:375px;height:280px;" />
        </li>
        <li class="item_one">
          <p style="color:#FF4700">建议尺寸：750*560像素</p>
        </li>
        <li class="item_one">
          <p>微信配置链接：{{data.link}}</p>
        </li>
      </ul>
      <div class="foot_btns">
        <button class="save_btn" @click="save" v-points>保存</button>
      </div>
    </div>
    <div v-else class="adSet">
      <div class="adSet_ttile">
        <span>注：按照顺序由大到小显示，即数字大的在前面，最多显示选中的前10条。</span>
        <div class="ttile_btn">
          <button class="save" @click="addAd" v-points>保存</button>
          <button class="add" @click="add" v-points>新增</button>
        </div>
      </div>
      <ul class="adSet_item">
        <li class="item_wrap" v-for="(item,index) in adData" :key="index">
          <img src="../../assets/delect.png" alt class="deleteIcon" @click="delectItem(index)" />
          <ul class="content">
            <li class="content_one">
              <el-checkbox-group v-model="item.type" @change="choice(index)">
                <el-checkbox :label="1">官网</el-checkbox>
                <el-checkbox :label="2">微站</el-checkbox>
                <el-checkbox :label="3">APP</el-checkbox>
              </el-checkbox-group>
            </li>
            <li class="content_two">
              <span>顺序：</span>
              <el-input v-model="item.sort" @input="item.sort=item.sort.replace(/[^\d]/g,'')"></el-input>
              <span class="span_text">只能输入正整数，不可重复</span>
            </li>
            <li class="content_two">
              <span>链接：</span>
              <el-input v-model="item.url"></el-input>
            </li>
            <li class="content_three">
              <div class="three_item">
                <p>微站&APP</p>
                <div @click="adweiPhoto(index)" class="item_photo">
                  <el-upload
                    :action="`${$uploadUrl}/erp/qiniu/uploadImg`"
                    list-type="picture-card"
                    :on-success="handleAvatarSuccessad"
                    accept=".png, .jpg, .jpeg"
                    :multiple="true"
                    :show-file-list="false"
                    :headers="headers"
                  >
                    <img
                      :src="'http://'+item.appPicture"
                      alt
                      v-if="item.appPicture"
                      style="width:320px;height:120px;"
                    />
                    <i class="el-icon-plus" v-else></i>
                  </el-upload>
                </div>
                <p style="color:#CCCCCC">建议大小：720*120像素</p>
              </div>
              <div class="three_item">
                <p>官网</p>
                <div @click="adweiPhoto(index)" class="item_photo">
                  <el-upload
                    :action="`${$uploadUrl}/erp/qiniu/uploadImg`"
                    list-type="picture-card"
                    :on-success="handleAvatarSuccessweb"
                    accept=".png, .jpg, .jpeg"
                    :multiple="true"
                    :show-file-list="false"
                    :headers="headers"
                  >
                    <img
                      :src="'http://'+item.pcPicture"
                      alt
                      v-if="item.pcPicture"
                      style="width:320px;height:120px;"
                    />
                    <i class="el-icon-plus" v-else></i>
                  </el-upload>
                </div>
                <p style="color:#CCCCCC">建议大小：720*120像素</p>
              </div>
              <span style="color:#ff9065">为确保图片清晰请按照规定尺寸上传</span>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import VueCookies from "vue-cookies";
import {
  queryWebsiteCompany,
  webSystem,
  weiSystem,
  addAd,
  queryAd
} from "@/api/systemSetup";
export default {
  data() {
    let token = sessionStorage.getItem("accessToken") || "";
    let permisList = JSON.parse(sessionStorage.getItem("permisList"));
    return {
      permisList,
      indexPhoto: "", //当前添加图片的下标
      headers: { accessToken: token },
      isActive: 0, //当前选中tab
      tabData: ["基础信息"],
      isShow: true,
      data: {
        weiName: "",
        weiLogo: "",
        homePicture: "",
        weiHousePicture: ""
      },
      adData: []
    };
  },
  mounted() {
    this.queryDetail(); //查询详情
    this.getList(); //查询广告
  },

  methods: {
    permisShow(data) {
      // 权限配置
      let result = this.permisList.indexOf(data);
      if (result >= 0) {
        return true;
      } else {
        return false;
      }
    },
    //查询广告
    getList() {
      this.$post(queryAd).then(res => {
        if (res.success === true) {
          this.adData = res.data;
        }
      });
    },
    //新增广告
    add() {
      this.adData.push({
        type: [],
        sort: "",
        url: "",
        appPicture: "",
        pcPicture: ""
      });
    },
    //保存广告
    addAd() {
      if (this.adData) {
        this.adData.map((item, index) => {
          item.type = item.type.join(",");
        });
        let params = {
          list: JSON.stringify(this.adData)
        };
        this.$post(addAd, params).then(res => {
          if (res.success) {
            this.$message({
              message: res.msg,
              type: "success",
              duration: 1000
            });
            this.getList();
          } else {
            this.$message({
              message: res.msg,
              type: "error",
              duration: 1000
            });
          }
        });
      }
    },
    //删除广告
    delectItem(index) {
      this.adData.splice(index, 1);
    },
    //查询详情
    queryDetail() {
      this.$post(queryWebsiteCompany).then(res => {
        if (res.success) {
          this.data = res.data;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
            duration: 1000
          });
        }
      });
    },
    //保存
    save() {
      let params = Object.assign([], this.data);
      if (params.remindEmployee) {
        delete params.remindEmployee;
      }
      if (params.remindEmployeeNames) {
        delete params.remindEmployeeNames;
      }
      this.$post(weiSystem, params).then(res => {
        if (res.success) {
          this.$message.success({
            message: res.msg,
            type: "success",
            duration: 1000
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
            duration: 1000
          });
        }
      });
    },
    //当前选择图片的下标
    adweiPhoto(index) {
      this.indexPhoto = index;
    },
    //选择平台
    choice(index) {
      if (
        this.adData[index].type.indexOf(2) == -1 &&
        this.adData[index].type.indexOf(3) == -1
      ) {
        this.adData[index].appPicture = "";
      }
      if (this.adData[index].type.indexOf(1) == -1) {
        this.adData[index].pcPicture = "";
      }
    },
    //广告的微站的图片上传成功
    handleAvatarSuccessad(file) {
      if (
        this.adData[this.indexPhoto].type.indexOf(2) == -1 &&
        this.adData[this.indexPhoto].type.indexOf(3) == -1
      ) {
        this.adData[this.indexPhoto].appPicture = "";
        this.$message({
          message: "请选择上传平台",
          type: "error",
          duration: 1000
        });
      } else {
        this.adData[this.indexPhoto].appPicture = file.uri;
      }
    },
    //广告的微站的图片上传成功
    handleAvatarSuccessweb(file) {
      if (this.adData[this.indexPhoto].type.indexOf(1) == -1) {
        this.adData[this.indexPhoto].pcPicture = "";
        this.$message({
          message: "请选择上传平台",
          type: "error",
          duration: 1000
        });
      } else {
        this.adData[this.indexPhoto].pcPicture = file.uri;
      }
    },
    //上传成功
    handleAvatarSuccess(file) {
      this.data.homePicture = file.uri;
    },
    handleAvatarSuccesslogo(file) {
      this.data.weiLogo = file.uri;
    },
    handleAvatarSuccesswei(file) {
      this.data.weiHousePicture = file.uri;
    },
    //动态绑定class
    ClassChang(index) {
      this.isActive = index;
      if (this.isActive === 0) {
        this.isShow = true;
      } else if (this.isActive === 1) {
        this.isShow = false;
      }
    }
  }
};
</script>

<style lang='less'>
.microStationSetup {
  width: 100%;
  min-height: 100%;
  padding: 30px 622px 30px 22px;
  overflow: hidden;
  background: #ffffff;
  .key_title {
    font-size: 14px;
    color: #999999;
    margin-bottom: 30px;
    margin-left: 0;
    display: flex;
    span {
      width: 80px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
    }
    .activeBtn {
      width: 80px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      background: #ff9065;
      color: #fff;
    }
  }
  .basicSet {
    font-size: 14px;
    .basicSet_item {
      .item_one {
        display: flex;
        align-items: center;
        > span {
          min-width: 76px;
        }
        > img {
          width: 375px;
          height: 180px;
        }
        .el-input {
          width: 276px;
          input {
            height: 30px;
          }
        }
        margin-bottom: 20px;
      }
    }
    .foot_btns {
      float: right;
      button {
        width: 80px;
        height: 40px;
        border-radius: 4px;
        outline: none;
        border: none;
        font-size: 16px;
        color: #ffffff;
        &.save_btn {
          background: rgb(94, 110, 217);
        }
      }
    }
  }
  .adSet {
    font-size: 14px;
    .adSet_ttile {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      > span {
        color: #ff9065;
      }
      .ttile_btn {
        > button {
          width: 100px;
          height: 30px;
          line-height: 30px;
          border-radius: 4px;
          outline: none;
          border: none;
          font-size: 14px;
          color: #ffffff;
          &.save {
            background: #5e75e6;
            margin-right: 10px;
          }
          &.add {
            background: #5e75e6;
          }
        }
      }
    }
    .adSet_item {
      .item_wrap {
        // width: 100%;
        padding: 30px;
        overflow: hidden;
        border: 1px solid #cccccc;
        position: relative;
        margin-bottom: 20px;
        .deleteIcon {
          position: absolute;
          right: 0px;
          top: 0px;
        }
        .content {
          .content_two {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .el-input {
              width: 276px;
              input {
                height: 30px;
              }
            }
            .span_text {
              margin-left: 10px;
              color: #ff9065;
            }
          }
          .content_three {
            display: flex;
            align-items: center;
            .three_item {
              width: 322px;
              text-align: center;
              margin-right: 20px;
              .item_photo {
                margin: 20px 0;
                .el-upload--picture-card {
                  width: 322px;
                  height: 122px;
                  line-height: 122px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>